module.exports = __webpack_public_path__ + "img/NewMiniBusIcon.12da6e3a.svg";